import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelFactory, ModelEditorFactory } from '@leverege/ui-plugin';
import { Pane, Checkbox, Label, Content, Text, Flex, TabPane, Selector } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import Model from "./SelectionTypeModel.js"; // import Details from '../detail/Details'
// import DetailListRenderer from './DetailListRenderer'
import S from './SelectionTypeEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.detail.selection.SelectionTypeEditor');
const PLACEMENT_OPTIONS = [{
  value: null,
  get name() {
    return t('default');
  }
}, {
  value: 'top-left',
  get name() {
    return t('top-left');
  }
}, {
  value: 'top',
  get name() {
    return t('top');
  }
}, {
  value: 'top-right',
  get name() {
    return t('top-right');
  }
}, {
  value: 'right',
  get name() {
    return t('right');
  }
}, {
  value: 'bottom-right',
  get name() {
    return t('bottom-right');
  }
}, {
  value: 'bottom',
  get name() {
    return t('bottom');
  }
}, {
  value: 'bottom-left',
  get name() {
    return t('bottom-left');
  }
}, {
  value: 'left',
  get name() {
    return t('left');
  }
}];
function contentHeader(item) {
  if (item == null) {
    return null;
  }
  const model = ModelFactory.get(item.type);
  let name;
  if (model) {
    name = model?.getName(item);
  }
  if (name == null) {
    name = item.displayName || item.name || item.type || t('unknown');
  }
  return /*#__PURE__*/_jsx(Text, {
    variant: "subTitle",
    children: name
  });
}
function SelectionTypeEditor(props) {
  const {
    value,
    objectType,
    placementHandled
  } = props;
  if (value == null) {
    return null;
  }
  const onModelChange = useValueChange(Model, props);
  const editor = ModelEditorFactory.create(value.details, {
    objectType,
    eventData: 'setDetails',
    onChange: onModelChange
  });
  if (placementHandled) {
    return editor;
  }
  return /*#__PURE__*/_jsxs(TabPane, {
    style: {
      position: 'relative',
      height: '100%'
    },
    children: [/*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('attributes'),
      tabId: "attrs",
      children: /*#__PURE__*/_jsx(Content, {
        className: S.tab,
        children: /*#__PURE__*/_jsx(Content.Area, {
          children: editor
        })
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: "Placement",
      tabId: "placement",
      children: /*#__PURE__*/_jsxs(Pane, {
        variant: "editor|padding",
        className: S.grid,
        children: [/*#__PURE__*/_jsxs(Flex, {
          variant: "rowM",
          align: "center",
          className: S.fill,
          children: [/*#__PURE__*/_jsxs(Label, {
            children: [t('visible'), " "]
          }), /*#__PURE__*/_jsx(Checkbox, {
            value: Model.getVisible(value),
            onChange: onModelChange,
            eventData: "setVisible"
          })]
        }), /*#__PURE__*/_jsx(Label, {
          variant: "input",
          children: t('placement')
        }), /*#__PURE__*/_jsx(Selector, {
          eventData: "setPlacement",
          value: Model.getPlacement(value),
          values: PLACEMENT_OPTIONS,
          onChange: onModelChange
        })]
      })
    })]
  });
}
export default SelectionTypeEditor;